/**
 * Eventos do turno do agente de IA em streaming, emitidos pelo ebarn-node na
 * room do chat (ver ebarn-node/docs/specs/chat-agente-streaming-zihin-sdk.md,
 * Bloco 4.5). `idTemp` é o mesmo da mensagem final: o `savedMessage` com esse
 * `idTemp` substitui o balão em streaming.
 */
interface AIStreamBase {
  chatHash: string;
  idTemp: string;
}

export type AIStreamEvent =
  | (AIStreamBase & { type: 'start'; from: number; time: string })
  | (AIStreamBase & { type: 'delta'; seq: number; text: string })
  | (AIStreamBase & { type: 'reset'; seq: number })
  | (AIStreamBase & { type: 'status'; seq: number; label: string })
  | (AIStreamBase & { type: 'end'; messageId?: string })
  | (AIStreamBase & { type: 'error'; error: string });

/** Nome do evento do socket para cada tipo de `AIStreamEvent`. */
export const AI_STREAM_SOCKET_EVENTS: Record<AIStreamEvent['type'], string> = {
  start: 'aiStreamStart',
  delta: 'aiStreamDelta',
  reset: 'aiStreamReset',
  status: 'aiStreamStatus',
  end: 'aiStreamEnd',
  error: 'aiStreamError',
};
